import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import { ReactElement, useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PeriodValue } from '../../../../../../../../types/periodValue'
import { useSandboxBankTransactionsFilters } from '../../../../hooks/useSandboxBankTransactionsFilters'

export const BankTransactionsDateSelector = (): ReactElement => {
  const { organization } = useUserOrganization()
  const [filters, setFilters] = useSandboxBankTransactionsFilters()

  const handleChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }

      const encodedPeriodValue = encodePeriodValue(periodValue, organization.id)
      setFilters({ period: encodedPeriodValue })
    },
    [organization, setFilters],
  )

  return <GlobalPeriodSelect encodedPeriod={filters.period} onChange={handleChange} />
}
